module.exports = __webpack_public_path__ + "media/images/photo/Commercial/slider2-8ef8751b88153469a8be1deee5935429.png";